import React, { FC } from "react";
import { makeStyles, Typography } from "@material-ui/core";
import Loading from "../../../components/Loading";
import Error from "../../../components/Error";
import { useBillingPage } from "../BillingContext";
import BillingCard from "./BillingCard";
import { IGetBillingReceiptFrontendModel } from "../types";

const useStyles = makeStyles(() => ({
  root: {
    padding: 24,
    minHeight: 245,
    backgroundColor: "#FFFFFF",
    boxShadow: "0px 0px 8px #C2C9D682",
    borderRadius: 15,
    minWidth: 732,
    position: "relative",
    overflow: "hidden",
  },
  billingContainer: {
    marginTop: 24,
  },
  loading: {
    position: "absolute",
  },
  title: {
    fontSize: 16,
    fontWeight: "bold",
    color: "#231F20",
  },
  error: {
    marginTop: 74,
  },
}));

const FilterResults: FC = () => {
  const {
    isLoading,
    billingReceipts,
  }: {
    isLoading: boolean;
    billingReceipts: IGetBillingReceiptFrontendModel[];
  } = useBillingPage();

  const classes = useStyles();

  return (
    <div className={classes.root}>
      {!!isLoading && <Loading className={classes.loading} />}
      <Typography className={classes.title} component={"h2"}>
        Billing
      </Typography>
      <div className={classes.billingContainer}>
        {billingReceipts.map((billing) => (
          <BillingCard
            key={billing.id}
            avatar={billing.avatar}
            studentName={billing.studentName}
            degree={billing.degreeName}
            level={billing.levelName}
            schoolName={billing.schoolName}
            major={billing.majorName}
            grade={billing.grade}
            amount={billing.amountWithCurrency}
            receiptImage={billing.receiptImage}
            schoolType={billing.schoolType}
            language={billing.language}
            category={billing.category}
          />
        ))}
      </div>
      {!billingReceipts.length && !isLoading && (
        <Error
          className={classes.error}
          fullHeight={false}
          icon={"search"}
          text={"You have no results for now."}
        />
      )}
    </div>
  );
};

export default React.memo(FilterResults);
